<template>
  <div
    class="pl-[248px] w-full"
    v-if="hasNavigationBar"
  >
    <jade-navigation-bar
      :label="$t(label)"
      :navigateType="navigateType"
      :hideNavigation="hideNavigation"
      background="body"
      @onNavigate="onNavigate"
      class="h-16"
    >
      <template
        v-if="navigationAction"
        #trailingItem
      >
        <jade-button
          v-if="navigationAction?.click"
          size="medium"
          variant="primary-solid"
          @click="navigationAction.click"
        >
          {{ $t(navigationAction.label) }}
        </jade-button>

        <component
          v-else-if="navigationAction?.component"
          :is="navigationAction.component"
        />
      </template>
    </jade-navigation-bar>
  </div>
</template>
<script>
import { JadeNavigationBar } from '@jade'
export default {
  name: 'AppNavigationBar',
  components: {
    JadeNavigationBar,
    JadeButton: () => import('@jade/JadeButton')
  },
  data () {
    return {
      navigationBar: {}
    }
  },
  computed: {
    hasNavigationBar () {
      return Object.keys(this.navigationBar).length > 0
    },
    hideNavigation () {
      return !this.navigationBar.navigateTo
    },
    label () {
      return this.navigationBar.label
    },
    navigateType () {
      return this.navigationBar?.navigateType
    },
    navigateTo () {
      return this.navigationBar?.navigationTo
    },
    navigationAction () {
      return this.navigationBar?.navigationAction?.(this.$router)
    }
  },
  watch: {
    $route () {
      this.updateNavigationBar()
    }
  },
  mounted () {
    this.updateNavigationBar()
  },
  methods: {
    updateNavigationBar () {
      this.navigationBar = { ...this.$route.meta.navigationBar }
    },
    onNavigate () {
      const { name, params } = this.navigationBar.navigateTo(
        this.$router.params
      )
      this.$router.push({
        name,
        params
      })
    }
  }
}
</script>

<i18n src="../AppBreadcrumb/breadcrumb.locale.json"></i18n>
